import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Meeting from "@/services/meeting";
import type { EditMeeting } from "@/dtos/Meeting.dto";

export function useEditMeeting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EditMeeting) => {
      const result = await Meeting.editMeeting(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update meeting");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meetings"] });
      queryClient.invalidateQueries({ queryKey: ["meetingStats"] });
    },
  });
}
